module.exports = "/assets/archetype-jealousy.webp"